import { useNavigate } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { FadeUp } from "./Reveal";

export default function Showroom() {
  const { t } = useLang();
  const navigate = useNavigate();
  const go = () => {
    sessionStorage.setItem("gg_home_scroll", String(window.scrollY));
    navigate("/showroom");
  };
  return (
    <section id="showroom" data-testid="showroom-section" className="py-20 md:py-24">
      <FadeUp>
        <div className="grid lg:grid-cols-12 lg:h-[75vh]" data-testid="showroom-hq">
          <div className="lg:col-span-4 px-8 md:px-14 py-12 lg:py-0 flex flex-col justify-center">
            <MapPin className="text-brass mb-8" size={30} strokeWidth={1.1} />
            <p className="eyebrow mb-2">{t.showroom.overline}</p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl text-cream tracking-tight">{t.showroom.city}</h2>
            <p className="mt-7 text-cream font-medium">Green Gate S.r.l.</p>
            <p className="mt-1 text-stone font-light leading-relaxed whitespace-pre-line">{t.contact.info.showroom}</p>
            <p className="mt-3 text-stone font-light">{t.contact.info.phone}</p>
            <button
              data-testid="showroom-cta"
              onClick={go}
              className="mt-8 self-start inline-flex items-center gap-3 text-[12px] uppercase tracking-[0.18em] text-brass hover:text-cream border-b border-brass/40 pb-1.5 transition-colors duration-300"
            >
              {t.showroom.cta}
              <ArrowRight size={15} />
            </button>
          </div>
          <div className="lg:col-span-3 min-h-[260px] overflow-hidden order-2 lg:order-none">
            <img
              loading="lazy"
              decoding="async"
              src="/images/showroom/ingresso.webp"
              alt="Ingresso dello showroom Green Gate in Piazza delle Cinque Scole, Roma"
              className="w-full h-64 lg:h-full object-cover grayscale"
            />
          </div>
          <div className="lg:col-span-5 min-h-[300px] order-1 lg:order-none">
            <iframe
              data-testid="showroom-map"
              title="Mappa showroom Green Gate"
              src="https://www.google.com/maps?q=Piazza+delle+Cinque+Scole+40-41,+00186+Roma&z=16&output=embed"
              className="w-full h-72 lg:h-full grayscale contrast-[0.95] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </FadeUp>
    </section>
  );
}
